module.exports = new __parcel__URL__("Bronze3.8af22458.png").toString();